<template>

    <p :class="[inputLength > limit ? limiterClass : '', 'inputCounter']">
        <!-- <span v-if="inputData.length >= limit" class="text">ACHTUNG: der Text überschreitet die maximale Zeichenlänge</span> -->
        <span v-if="inputLength > limit" class="text">ACHTUNG: der Text überschreitet die maximale Zeichenlänge!</span>
        <template v-if="warningOnly != true">
            <span> {{ inputLength }}</span> / <strong>{{ limit }}</strong>
        </template>
    </p>


</template>


<script>

export default {

    props: {
        inputData: {
            type: String,
            default: ""
        },
        warningOnly: {
            type: Boolean,
            default: false
        },
        limit: {
            type: Number,
            default: 100
        }
    },

    computed: {

		inputLength() {

            /*
            if (this.inputData.length == this.limit) {
                this.$emit('update:inputData', this.inputData.slice(0, this.limit));
            }
            */
            return this.stripHTML(this.inputData).length;
		},

		limiterClass() {

			if (this.inputData.length > this.limit) {
				return 'text-danger';
			}

            else if(this.inputData.length <= this.limit) {
                return "text-ok";
            }

			return '';

		}

	},
    methods: {

        stripHTML(string) {

            var tmp = document.createElement("div");
            tmp.innerHTML = string;
            return tmp.textContent || tmp.innerText || "";

        },

    }

}

</script>

<style>
    .inputCounter.text-danger .text {
        font-weight: bold;
    }
</style>
